    import { useSelector } from 'react-redux';

export const Regions = {
    getList: () => {
        const app = useSelector((state) => state.app);
        return app.data.regions.filter( (item) => { return item.active === true} );
    },

    getRegionByCode: (code) => {
        const app = useSelector((state) => state.app);
        const results = app.data.regions.filter( (item) => { return item.code === code} );
        if (results.length) {
            return results[0];
        }
        return false;
    }
}